import React from 'react';
import * as PropTypes from 'prop-types';
import { ApplyMenuButton } from 'components/Kizen/Menu';

export default function ApplySelectButton({ onClick, select, ...props }) {
  return (
    <ApplyMenuButton
      onClick={(ev) => {
        select.selectProps.selectManager.onMenuClose();
        // This is a special case for date pickers so they can be closed in the same
        // manner as normal selects
        if (select.selectProps.handleClose) {
          select.selectProps.handleClose();
        }
        if (onClick) onClick(ev);
        select.selectProps.selectManager.props.handleClickApply?.(ev);
      }}
      {...props}
    />
  );
}

ApplySelectButton.propTypes = {
  onClick: PropTypes.func,
  select: PropTypes.object.isRequired,
};

ApplySelectButton.defaultProps = {
  onClick: null,
};

ApplySelectButton.enrich = {
  select: true,
};
